<template>
  <div class="content">
    <div class="box">
      <div class="swiper-content">
        <div style="width: 500px;">
          <SwiperContent />
        </div>
        <a-carousel
          :dots="false"
          style="width: 640px"
          ref="swiper"
        >
          <div class="swiper-box" v-for="item in iconList" :key="item.fileHttpUrl">
            <img
              :src="item.fileHttpUrl">
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="choose(true)"><img src="../../../assets/images/icon_carousel_left_white.png"></p>
          <p @click="choose(false)"><img src="../../../assets/images/icon_carousel_right_white.png"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperContent from './swiper-content'
import {
  getPic,
  getStep,
  getDetail
} from '@/api/foreignCompanyService'
import {
  getFileDetails
} from '@/api/file'
export default {
  name: 'information-consulting',
  components: {
    SwiperContent
  },
  data () {
    return {
      iconList: []
    }
  },
  created () {
    getPic('RESD2CAD17ACAFDA71', '').then(async res => {
      this.iconList = JSON.parse(JSON.stringify([]))
      const data = this._.get(res, 'data.records', [])
      for (let i of data) {
        const pic = await getDetail(i.picCode)
        const img = await getFileDetails(this._.get(pic, 'data.appCode'), this._.get(pic, 'data.tenantCode'), [this._.get(pic, 'data.contentPicFileDtoList.0.fileCode')])
        this.iconList.push(...Object.values(this._.get(img, 'data')))
      }
    })
  },
  methods: {
    choose (isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev()
      } else {
        this.$refs && this.$refs.swiper.next()
      }
    },
  }
}
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  background: white;
  position: relative;
  margin-top: 50px;
}
.box {
  width: 1140px;
  height: 384px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FAF5F5;
  position: relative;
}
.swiper-content {
  height: 480px;
  width: 1140px;
  position: relative;
  display: flex;
  .swiper-box {
    width: 570px;
    height: 384px;
    background: #DCDCDC;
    text-align: center;
    position: relative;
    img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    top: 158px;
    width: 42px;
    height: 70px;
    background: #000000;
    opacity: 0.8;
    line-height: 70px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: 43.9%;
  }
  p:last-of-type {
    right: 0px;
  }
}
.swiper-title {
  width: 341px;
  height: 77px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 48px;
  text-align: left;
  margin-top: 33px;
}
.swiper-desc {
  width: 438px;
  height: 100px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999BA3;
  text-align: left;
  margin-top: 33px;
}
.swiper-time {
  width: 181px;
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #959DA9;
  position: absolute;
  bottom: 80px;
  left: 0;
}
/deep/.slick-track {
  width: 570px;
}
/deep/ .ant-carousel .slick-dots li button {
  width: 16px;
  height: 16px;
  background: #D7CDBE;
}
/deep/ .ant-carousel .slick-dots li.slick-active button {
  background: #CDAD7F;
}
/deep/ .ant-carousel .slick-dots-bottom {
  bottom: 30px;
  left: -43px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/foreignCompanyService/siderContent-02.vue